
import 'pages/sections/section-list.tag'
import 'pages/sections/section-list-items.tag'
import 'pages/sections/section-edit.tag'
riot.tag2('sections', '  <section-list if="{!edit}"></section-list>\n  <section-edit if="{edit}"></section-edit>\n', '', '', function(opts) {
'use strict';

var self = this;
self.edit = false;

var route = riot.route.create();

route('/sections/([0-9]+)', function (id) {
    observable.trigger('section-edit', id);
    self.edit = true;
    self.update();
});

route('/sections', function () {
    self.edit = false;
    self.update();
});

route('/sections/new..', function () {
    var q = riot.route.query();
    var sect = q.section;
    self.edit = true;
    observable.trigger('section-new', sect);
    self.update();
});

route('/sections/new', function () {
    riot.route('/sections');
});

self.on('mount', function () {
    riot.route.exec();
});
});


// WEBPACK FOOTER //
// ./pages/sections/sections.tag